








































































































import PageBody from "@/components/PageBody.vue";
import PageHeader from "@/components/PageHeader.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import DateUtils from "@/utils/dayjs";
import { UserHttp } from "@/mixins/http/user";
import ConfirmDeleteDialog from "@/components/ConfirmDeleteDialog.vue";

@Component({
	components: {
		"page-header": PageHeader,
		"page-body": PageBody,
		"confirm-delete-dialog": ConfirmDeleteDialog,
	},
})
export default class AccountGeneral extends Mixins(DateUtils, UserHttp) {
	showConfirmDelete: boolean = false;
	confirmDeleteBody: string =
		"Deleting your account is irreversible. We will stop tracking all your domains and all your notification groups will be deleted.";
	showConfirmDeleteDialog(): void {
		this.showConfirmDelete = true;
	}

	useLocalTimezone: boolean = false;

	showErrorSnackbar: boolean = false;
	errorMessage: string = "";

	mounted() {
		this.getTimezoneConfigFromLocalStorage();
	}

	attemptDeleteAccount(): void {
		this.deleteCurrentAccount()
			.then(() => {
				this.$store.dispatch("account/resetStore");
				localStorage.removeItem("access_token");
				this.$router.push("/auth/login");
			})
			.catch(() => {
				this.showErrorSnackbar = true;
				this.errorMessage = "An error occurred trying to delete your account";
			});
	}

	getTimezoneConfigFromLocalStorage() {
		if (localStorage.getItem("useLocal")) {
			this.useLocalTimezone = localStorage.getItem("useLocal") == "true";
		} else {
			this.useLocalTimezone = false;
			localStorage.setItem("useLocal", this.useLocalTimezone + "");
		}
	}

	@Watch("useLocalTimezone")
	useLocalTimezoneChanged(newVal: boolean) {
		localStorage.setItem("useLocal", newVal + "");
	}
}
